import {
    SETTING, USER_STEP
} from "../action-types";

const getLang = () => {
    var jsSrc = navigator.language.toLowerCase();
    if (jsSrc.indexOf("zh") >= 0) {
        // 假如浏览器语言是中文
        return "zh";
    } else if (jsSrc.indexOf("en") >= 0) {
        // 假如浏览器语言是英文
        return "en";
    } else {
        // 假如浏览器语言是其它语言
        return jsSrc;
    }
};


const initState: any = {
    language: getLang(),
    step: 0 // 进入页面渲染第几个tab
};

    export default function settingReducer(state = initState, action: any) {
    switch (action.type) {
        /* 国际化 */
        case SETTING:
            return Object.assign({}, state, {language: action.payload});
        case USER_STEP:
            return Object.assign({}, state, {step: action.payload});
        default:
            return state;
    }
}
